//Import React
import React, { useContext, useEffect, useState } from "react";
//Import Context
import { AppContext } from "../../../../contexts/AppContext";
//Import Recharts
import { Bar, BarChart, CartesianGrid, Cell, Tooltip, XAxis, YAxis } from "recharts";
//Import Icob
import arrowSide from '../../../../assets/icons/arrowSide.svg';

const AnnualComplianceHolder = ({ selectedHolder, setClose }) => {
    const { pmeList, establishmentList, dataProjects } = useContext(AppContext);
    const [annualComplianceData, setAnnualComplianceData] = useState([]);
    
    useEffect(() => {
        //Calcular cumplimiento por año para el sostenedor seleccionado
        const calculateAnnualCompliance = () => {
            //Si no hay sostenedor seleccionado, retornar array vacío
            if (!selectedHolder) return [];
            //filtrar establecimientos del sostenedor
            const holderEstablishment = establishmentList.filter(est => est.projectId === (selectedHolder?.id ?? selectedHolder));

            const annualComplianceCalculation = pmeList
                .filter(pme =>
                    holderEstablishment.some(est => est.id === pme.establishmentId)
                )
                .reduce((acc, pme) => {
                    const existingYear = acc.find(item => item.year === pme.yearPME);
                    const totalSubsidyAmount = pme.activities.reduce(
                        (sum, activity) => sum + (activity.totalSubsidyAmount || 0),
                        0
                    );
                    const totalAccruedBalance = pme.activities.reduce(
                        (sum, activity) => sum + (activity.accruedBalance || 0),
                        0
                    );
                    const compliancePercentage = totalSubsidyAmount > 0
                        ? Math.min(100, (totalAccruedBalance * 100) / totalSubsidyAmount)
                        : 0;

                    if (existingYear) {
                        existingYear.compliancePercentage = (
                            (existingYear.compliancePercentage * existingYear.count + compliancePercentage) / (existingYear.count + 1)
                        );
                    } else {
                        acc.push({
                            year: pme.yearPME,
                            compliancePercentage: compliancePercentage,
                            count: 1
                        });
                    }

                    return acc;
                }, [])
                .map(item => ({
                    name: `PME ${item.year}`,
                    value: Number(item.compliancePercentage.toFixed(1)),
                    year: item.year
                }))
                // Ordenar de menor a mayor año
                .sort((a, b) => a.year - b.year);

            return annualComplianceCalculation;
        }

        setAnnualComplianceData(calculateAnnualCompliance());
    }, [selectedHolder, pmeList, establishmentList]);

    // Si no hay datos o no se ha seleccionado un sostenedor
    if (!selectedHolder || annualComplianceData.length === 0) {
        return (
            <section className='annual-compliance-holder flex'>
                <p>Seleccione un sostenedor para ver el informe de cumplimiento anual</p>
            </section>
        );
    }

    // Colores personalizados
    const COLORS = ['#5664D2', '#7E57C2', '#3F51B5', '#2196F3', '#00BCD4'];

    const handleClose = (e) => {
        e.preventDefault();
        setClose(false);
    };

    return (
        <section className='annual-compliance-holder flex'>
            <span className='info-holder flex'>
                <h3>Cumplimiento PME Anual</h3>
                <img src={arrowSide} className='icon' alt='Icono flecha' />
                <p>{selectedHolder?.value ?? dataProjects.find(project => project.id === selectedHolder).nameProject}</p>
                <button onClick={handleClose}>Cerrar</button>
            </span>

            <div className="chart-container">
                <BarChart
                    width={500}
                    height={300}
                    data={annualComplianceData}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        dataKey="name"
                        label={{
                            value: 'Año PME',
                            position: 'insideBottom',
                            offset: -8
                        }}
                    />
                    <YAxis
                        domain={[0, 100]}
                        label={{
                            value: '% Cumplimiento',
                            angle: -90,
                            position: 'insideLeft'
                        }}
                    />
                    <Tooltip />
                    <Bar dataKey="value" fill="#5664D2">
                        {annualComplianceData.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={COLORS[index % COLORS.length]}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </div>
        </section>
    );
};

export default AnnualComplianceHolder;